import ReactPaginate from "react-paginate";
import { Icon } from "@iconify/react";

export const Pagination = ({ pageCount, handlePageClick, offset }: any) => {
  return (
    <ReactPaginate
      previousLabel={
        <Icon
          icon={"ic:round-keyboard-arrow-left"}
          className="mt-[2px] mr-2"
          width={24}
        />
      }
      nextLabel={
        <Icon
          icon={"ic:round-keyboard-arrow-right"}
          className="mt-[2px] ml-2"
          width={24}
        />
      }
      breakLabel={"..."}
      breakClassName={"break-me"}
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={3}
      onPageChange={handlePageClick}
      containerClassName={"pagination"}
      activeClassName={"active"}
      forcePage={offset}
    />
  );
};

export default Pagination;
